const AssetsAPI = {
  methods: {
    uploadImage(file, cb) {
      let formData = new FormData();
      formData.append("imageFile", file);

      console.log("Attempting Image Upload...");

      let url = "";

      this.axios
        .post("https://assets.oregonstate.education/v1/image", formData)
        .then((response) => {
          console.log("Image Upload Response", response);
          url = response.data.message.url;
        })
        .catch((error) => {
          console.error("Image Upload Error", error);
        })
        .finally(() => {
          console.log("Completing Image Upload...");

          if (typeof cb === "function") {
            cb(url);
          }
        });
    },
    uploadPDF(file, cb) {
      let formData = new FormData();
      formData.append("pdfFile", file);

      console.log("Attempting PDF Upload...");

      let url = "";

      this.axios
        .post("https://assets.oregonstate.education/v1/pdf", formData)
        .then((response) => {
          console.log("PDF Upload Response", response);
          url = response.data.message.url;
        })
        .catch((error) => {
          console.error("PDF Upload Error", error);
        })
        .finally(() => {
          console.log("Completing PDF Upload...");

          if (typeof cb === "function") {
            cb(url);
          }
        });
    }
  }
};

export default AssetsAPI;
